import React from 'react';
import Store from "../../store";
export default class Arrow extends React.Component {
	constructor() {
		super()
	}
	prepareData() {
		let d = [
			`M ${this.props.path[0].x} ${this.props.path[0].y}`,
			`L ${this.props.path[this.props.path.length - 1].x} ${this.props.path[this.props.path.length - 1].y}`,
		];

		return d.join(' ');
	}

	render() {
		let d = this.prepareData();
	
		return (
			<>
				<svg>
					<defs>
						<defs>
							<marker id="triangle" viewBox="0 0 10 10"
								refX="1" refY="5"
								markerUnits="strokeWidth"
								markerWidth="10" markerHeight="10"
								orient="auto">
								<path d="M 0 0 L 10 5 L 0 10 z" fill={"black"} />
							</marker>
						</defs>
					</defs>
					<path
						markerEnd="url(#triangle)"
						d={d}
						stroke={this.props.color}
						strokeWidth={2}
						fill="none"
					/>
				</svg>
			</>

		);
	}
}